import styled, { css, keyframes } from 'styled-components';
import { body2, body2Bold, colors, spacing } from 'ui/theme';
import { ModalSize } from './Modal.constants';
import { MODAL_FOOTER_STYLES } from './Modal.styled';

const appear = keyframes`
  from {
    opacity: 0;
    transform: scale(1, 0);
  }
  to {
    opacity: 1;
    transform: scale(1, 1);
   }
`;

const disappear = keyframes`
  from {
    opacity: 1;
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    transform: scale(1, 0);
  }
`;

export const ActionsContainer = styled.div<{ size: ModalSize }>`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${spacing.half};

  &[data-has-message='true'] {
    justify-content: space-between;
  }

  ${({ size }) => (size && MODAL_FOOTER_STYLES[size]) || ``};
`;

export const Overlay = styled.div<{ isEnabled: boolean }>`
  background-color: ${colors.overlay};
  border-radius: ${spacing.threeQuarter};
  bottom: 0;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  transition: opacity 0.25s, visibility 0.25s;
  visibility: hidden;
  width: 100%;
  z-index: 9;
  ${({ isEnabled }) =>
    isEnabled &&
    css`
      opacity: 0.3;
      visibility: visible;
    `}
`;

export const Content = styled.dialog<{
  $animationTime: string;
  isEnabled: boolean;
  size: ModalSize;
}>`
  all: unset;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 0 0 ${spacing.threeQuarter} ${spacing.threeQuarter};
  bottom: 0;
  display: flex;
  gap: ${spacing.half};
  justify-content: space-between;
  left: 0;
  position: absolute;
  right: 0;
  transform-origin: bottom;
  z-index: 99;
  button {
    white-space: nowrap;
  }
  ${({ isEnabled, $animationTime }) =>
    isEnabled
      ? css`
          animation: ${appear} ${$animationTime} ease-out;
        `
      : css`
          animation: ${disappear} ${$animationTime} ease-in;
        `}

  padding: ${spacing.plusHalf}; ;
`;

export const ButtonsGroup = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const PrimaryActions = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const LabelText = styled.span`
  ${body2Bold}
  margin-right: ${spacing.quarter};
`;

export const HelpText = styled.span`
  ${body2}
  color: ${colors.textSecondary};
`;
